import script from "./TagModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagModal.vue?vue&type=script&setup=true&lang=ts"

import "./TagModal.vue?vue&type=style&index=0&id=78182a5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78182a5c"]])

export default __exports__